export enum EventPageSection {
  About = 'about',
  Agenda = 'agenda',
  Speakers = 'speakers',
  RelatedVideos = 'related-videos',
  FAQ = 'faq',
}
